import { Fragment } from "react";

import { Link, useMatches } from "react-router-dom";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

/**
 * Route handles opt into a breadcrumb label via `handle: { breadcrumb: "..." }`
 * (see src/routes/router.tsx). Routes without a handle are skipped, so
 * layout/index routes don't produce empty crumbs.
 */
interface RouteHandle {
  breadcrumb?: string;
}

export function RouteBreadcrumbs() {
  const matches = useMatches();
  const crumbs = matches.filter(
    (match) => (match.handle as RouteHandle | undefined)?.breadcrumb,
  );

  if (crumbs.length === 0) return null;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {crumbs.map((match, index) => {
          const label = (match.handle as RouteHandle).breadcrumb!;
          const isLast = index === crumbs.length - 1;
          return (
            <Fragment key={match.pathname}>
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={match.pathname}>{label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLast && <BreadcrumbSeparator />}
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
